import $ from 'jquery'
import Component from "../models/Component"

export default class LavoraConNoi extends Component {
    constructor(element, context) {
        super(element, context);
        $(() => {
            const $root = $(element);
            const $selectAzienda = $root.find('.js-filtro-azienda');
            const $selectSito = $root.find('.js-filtro-sito');
            const $cards = $root.find('.js-card-posizione');
            const $nessunRisultato = $root.find('.js-nessun-risultato');
            const $risultati = $root.find('.js-risultati-posizioni');
            const $filtriExtra = $root.find('.js-filtri-extra');
            const $resetFiltri = $root.find('.js-reset-filtri');

            // Opzioni "sito" originali, per poter ripristinare il filtro cascata azienda -> sito
            const sitoOptionsOriginali = $selectSito.find('option').clone();

            function aggiornaOpzioniSito() {
                const aziendaSelezionata = $selectAzienda.val();
                const sitoAttuale = $selectSito.val();

                $selectSito.empty();
                sitoOptionsOriginali.each(function () {
                    const $opt = $(this);

                    // Placeholder ("Scegliere un sito"): sempre presente.
                    if (!$opt.val()) {
                        $selectSito.append($opt.clone());
                        return;
                    }

                    // Un sito senza azienda assegnata non appartiene a nessun
                    // filtro: va mostrato solo quando non c'e' azienda scelta.
                    const aziendaOpzione = $opt.attr('data-azienda') || '';
                    if (!aziendaSelezionata || aziendaOpzione === aziendaSelezionata) {
                        $selectSito.append($opt.clone());
                    }
                });

                // Se il sito selezionato non è più tra le opzioni disponibili, resetta.
                if ($selectSito.find('option[value="' + sitoAttuale + '"]').length === 0) {
                    $selectSito.val('');
                } else {
                    $selectSito.val(sitoAttuale);
                }
            }

            function filtraRisultati() {
                const aziendaSelezionata = $selectAzienda.val();
                const sitoSelezionato = $selectSito.val();
                let visibili = 0;

                $cards.each(function () {
                    const $card = $(this);
                    const matchAzienda = !aziendaSelezionata || $card.attr('data-azienda') === aziendaSelezionata;
                    const matchSito = !sitoSelezionato || $card.attr('data-sito') === sitoSelezionato;
                    const visibile = matchAzienda && matchSito;
                    $card.toggle(visibile);
                    if (visibile) visibili++;
                });

                $nessunRisultato.toggleClass('hidden', visibili > 0);
                $risultati.toggleClass('hidden', visibili === 0);
            }

            function aggiornaVisibilitaFiltriExtra() {
                const aziendaScelta = !!$selectAzienda.val();
                $filtriExtra.toggleClass('hidden', !aziendaScelta);
                $resetFiltri.toggleClass('hidden', !aziendaScelta);
            }

            $selectAzienda.on('change', function () {
                aggiornaOpzioniSito();
                aggiornaVisibilitaFiltriExtra();
                filtraRisultati();
            });

            $selectSito.on('change', filtraRisultati);

            $resetFiltri.on('click', function () {
                $selectAzienda.val('');
                aggiornaOpzioniSito();
                aggiornaVisibilitaFiltriExtra();
                $selectSito.val('');
                filtraRisultati();
            });

            // Disclaimer privacy a due varianti nel form "Candidatura spontanea":
            // il PHP stampa entrambi i testi, qui si mostra quello dell'azienda scelta.
            // Nella pagina singola posizione la variante la decide il PHP: nessun toggle.
            const $disclaimers = $('.js-disclaimer-privacy');

            if ($disclaimers.length) {
                const $selectAziendaForm = $('select[name="azienda_interesse"]');

                // Mappa "valore opzione -> variante" calcolata dal PHP: la scelta non
                // passa da manipolazioni della stringa, che sbaglierebbero sui nomi
                // contenenti il separatore o sulle societa' dello stesso gruppo.
                let variantePerValore = {};
                try {
                    variantePerValore = JSON.parse($('.js-disclaimer-varianti').attr('data-varianti') || '{}');
                } catch (e) {
                    variantePerValore = {};
                }

                function aggiornaDisclaimer() {
                    const valore = ($selectAziendaForm.val() || '').toString().trim();
                    const variante = variantePerValore[valore] || 'default';

                    $disclaimers.each(function () {
                        const $el = $(this);
                        $el.toggleClass('hidden', $el.attr('data-variante') !== variante);
                    });
                }

                $selectAziendaForm.on('change', aggiornaDisclaimer);
                aggiornaDisclaimer();
            }

            // Campi upload custom (Allega CV / lettera di presentazione) nel form CF7
            // (sia sezione "Candidatura spontanea" del listing, sia pagina singola posizione).
            const $uploadBoxes = $('.upload-box');

            $uploadBoxes.each(function () {
                const $box = $(this);
                const $input = $box.find('input[type="file"]');
                if (!$input.length) return;

                function aggiornaNomeFile(fileList) {
                    $box.find('.upload-box-filename').remove();
                    if (fileList && fileList.length) {
                        $box.append('<span class="upload-box-filename">' + fileList[0].name + '</span>');
                    }
                }

                $input.on('change', function () {
                    aggiornaNomeFile(this.files);
                });

                $box.on('dragover dragenter', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $box.addClass('is-dragover');
                });

                $box.on('dragleave dragend', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $box.removeClass('is-dragover');
                });

                $box.on('drop', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $box.removeClass('is-dragover');
                    const dt = e.originalEvent.dataTransfer;
                    if (dt && dt.files && dt.files.length) {
                        $input[0].files = dt.files;
                        aggiornaNomeFile(dt.files);
                    }
                });
            });
        });
    }
}
